import { useState } from "react";
import EditPaymentInfo from "./EditPaymentInfo"
import { Button } from "antd";
import { getlabtaxInfo, updateTaxInfo } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { login, updateTaxInfoSlice } from "../../redux/reducers/authSlice";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";


const EditFinancialInfo = () =>{
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();

    const [inputValues, setInputValue] = useState({
        economicCode:myStore.auth.taxInfo.str_Economicode ? myStore.auth.taxInfo.str_Economicode  : "",
        nationalCode:myStore.auth.taxInfo.str_TaxnationalCode ? myStore.auth.taxInfo.str_TaxnationalCode  : " ",
        postalCode:myStore.auth.taxInfo.str_PostalCode ? myStore.auth.taxInfo.str_PostalCode  : " ",
        ownerNatioalCode:myStore.auth.taxInfo.str_TaxFullNameOwnernationalCode ? myStore.auth.taxInfo.str_TaxFullNameOwnernationalCode  : " ",
        address:myStore.auth.taxInfo.str_Address ? myStore.auth.taxInfo.str_Address  : " ",
        telePhone:""
    });

    const getLabTaxInfo = () => {

        getlabtaxInfo(myStore.auth.userId)
        .then((result:any) => {
            console.log(result);
            dispatch(login({loginType:"labuser",userId:myStore.auth.userId,
            userTitle:myStore.auth.userTitle,taxInfo:result.data.data,
            permission:undefined,
            
            manager:myStore.auth.manager
            ,int_minimumpayment:myStore.auth.int_minimumpayment}))        })    
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }
    function getFormValues(event: any) {       
        const { name, value } = event.target;       
        setInputValue({ ...inputValues, [name]: value });
    }

    const _modifyTaxInfo = (labId:any,values:any) => {
        updateTaxInfo(labId,values.economicCode,values.nationalCode,values.postalCode,
            values.ownerNatioalCode,values.address,values.telePhone)
        .then((result:any) => {
            if(result.status == 200) {
                sucessNotify("اطلاعات ثبت شد.");
                getLabTaxInfo();
            }
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })
    }

    
    const onClickSave =() =>{
        _modifyTaxInfo(myStore.auth.loginType === 'labuser' ? myStore.auth.userId : 0,inputValues);

    }
    return(
        <div style={{padding:'0 250px 20px 250px'}}>
            <EditPaymentInfo getFormValues={getFormValues} labTaxInfo={myStore.auth.taxInfo} />
            <Button type="primary" style={{ backgroundColor: "blue",float:'left' }} onClick={onClickSave} > ذخیره </Button>
        </div>
    )
}

export default EditFinancialInfo;

